<script setup lang="ts">
definePage({
  meta: {
    hideInMenu: true,
    activeMenuName: 'Demos',
  },
});
</script>

<template>
  <div></div>
</template>
